import http from './http';
import type { CandidateProfile, CandidateProfileListResponse, CreateCandidateProfileRequest, CandidateFilter } from '@/types/candidates/candidates.types';

export const candidateApi = {
  // POST /candidate-profiles
  create: (body: CreateCandidateProfileRequest) => http.post<{data: CandidateProfile}>('/candidate-profiles', body).then((r) => r.data.data),

  // PATCH /candidate-profiles/:id
  update: (id: string, body: Partial<CreateCandidateProfileRequest>) => http.patch<{data: CandidateProfile}>(`/candidate-profiles/${id}`, body).then((r) => r.data.data),

  // GET /candidate-profiles — list all candidates (for Recruiter role)
  getList: (params?: CandidateFilter) => http.get<CandidateProfileListResponse>('/candidate-profiles', { params }).then((r) => r.data),

  // GET /guest-candidate-profiles — public
  getGuestList: (params?: CandidateFilter) => http.get<CandidateProfileListResponse>('/guest-candidate-profiles', { params }).then((r) => r.data),

  // GET /candidate-profiles/:id
  getById: (id: string) => http.get<{data: CandidateProfile}>(`/candidate-profiles/${id}`).then((r) => r.data.data),

  // GET /candidate-profiles/by-account/:accountId
  getByAccountId: (accountId: string) => http.get<{data: CandidateProfile}>(`/candidate-profiles/by-account/${accountId}`).then((r) => r.data.data),

  // DELETE /candidate-profiles/:id
  remove: (id: string) => http.delete(`/candidate-profiles/${id}`).then((r) => r.data),

  // Hiding CV from recruiters
  hideFrom: (id: string, recruiterId: string) => http.post(`/candidate-profiles/${id}/hide-from/${recruiterId}`).then((r) => r.data),
  unhideFrom: (id: string, recruiterId: string) => http.delete(`/candidate-profiles/${id}/hide-from/${recruiterId}`).then((r) => r.data),
  getHiddenFrom: (id: string) => http.get<string[]>(`/candidate-profiles/${id}/hidden-from`).then((r) => r.data),
};
